import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { EditEvent, RemoveEvent } from '@progress/kendo-angular-grid';
import { Observable, Subscription } from 'rxjs';
import { IBaseSearchRequest, IGridResult } from 'src/app/core/models/base';
import { ICreateWearingPartCategoryRequest, IUpdateWearingPartCategoryRequest, IWearingPartCategory } from 'src/app/devices/models/wearing-part-categories';
import { WearingPartCategoryService } from 'src/app/devices/services/wearing-part-category.service';
import { ConfirmationDialogService } from 'src/app/shared/services/confirmation-dialog.service';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import * as Actions from "../../stores/global/wearing-part-categories/actions";
import { wearingPartCategoriesSelector, isLoadingSelector } from 'src/app/stores/global/wearing-part-categories/selectors';
import { WearingPartCategoryValidator } from 'src/app/shared/validators/wearing-part-category-validator';


@Component({
    selector: 'app-manage-wearing-parts-categories',
    templateUrl: './manage-wearing-parts-categories.component.html',
    styleUrl: './manage-wearing-parts-categories.component.scss',
    standalone: false
})
export class ManageWearingPartsCategoriesComponent implements OnInit {
  isLoading$: Observable<boolean>;
  wearingPartCategories$: Observable<IWearingPartCategory[]>;

  constructor(    
    private route : ActivatedRoute,
    private wearingPartCategoryService: WearingPartCategoryService,
    private appNotificationService: AppNotificationService,
    private confirmationDialogService : ConfirmationDialogService,
    private store: Store<AppStateInterface>) {
      this.isLoading$ = this.store.pipe(select(isLoadingSelector)),
      this.wearingPartCategories$ = this.store.pipe(select(wearingPartCategoriesSelector))
  }
  
  wearingPartCategories: IGridResult<IWearingPartCategory[]>;
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;
  selectedCategory: IWearingPartCategory = null;
  isDialogActive = false;
  public editForm: UntypedFormGroup;
  isInEditing = false;

  public searchRequest : IBaseSearchRequest = {
    pageNumber:0, 
    pageSize:999999
  }

  ngOnInit(): void {
    this.store.dispatch(Actions.getWearingPartCategories());
  }

  addHandler({ sender }){
    this.closeEditor(sender);
    this.isInEditing = false;

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, {
        validators: Validators.required,
        asyncValidators: WearingPartCategoryValidator(this.wearingPartCategoryService, null),
        updateOn: 'change'})
    });

    sender.addRow(this.formGroup);
  }

  public editHandler(args: EditEvent): void{
    this.closeEditor(args.sender);
    this.isInEditing = true;

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(
        args.dataItem.name, {
          validators: Validators.required, 
          asyncValidators: WearingPartCategoryValidator(this.wearingPartCategoryService, args.dataItem.id),
          updateOn: 'blur' 
        })
    });

    this.editedRowIndex = args.rowIndex;

    args.sender.editRow(args.rowIndex, this.formGroup);
  }

  public saveHandler(event) {
    const createRequest: ICreateWearingPartCategoryRequest = {
      name: event.formGroup.value.name,
    }

    const updateRequest: IUpdateWearingPartCategoryRequest = {
      id: event.dataItem.id,
      name: event.formGroup.value.name,
    }

    if (this.isInEditing) {
      this.store.dispatch(Actions.updateWearingPartCategory({ wearingPartCategory: updateRequest }));
    } else {
      this.store.dispatch(Actions.createWearingPartCategory({ wearingPartCategory: createRequest }));
    }
    
    event.sender.closeRow(event.rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
  
  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public removeHandler(args: RemoveEvent): void{
    var subscription : Subscription = new Subscription();
    this.confirmationDialogService.open();
    subscription = this.confirmationDialogService.decision$.subscribe(val => {
      if (val) {
        this.store.dispatch(Actions.deleteWearingPartCategory({ id: args.dataItem.id }))
        this.confirmationDialogService.updateValue(false);
      } else{
        subscription.unsubscribe();
      }
    });
  }

  closeDialog(){
    this.selectedCategory = null;
    this.isDialogActive = false;
  }

  onCancel(e: PointerEvent){
    e.preventDefault();
    this.closeDialog();
  }
}
